import React from 'react';
import axios from 'axios';
import moment from 'moment';
import FromToDateForm from "../../components/Forms/FromToDateForm";
import { Line } from "react-chartjs-2";

class FinanceStats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment.utc('2017-09-01').startOf('day'),
      endDate: moment.utc().endOf('day'),
      actualMoney: null,
      loaded: false,
      chartData: this.init_chart()
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.state.loaded) {
      this.getActualMoney();
      this.getChartData();
      this.setState({
        loaded: true,
      });
    }
  }

  handleChangeStart(date) {
    if (date <= this.state.endDate)
      this.setState({ startDate: date })
  }

  handleChangeEnd(date) {
    if (date >= this.state.startDate)
      this.setState({ endDate: date });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.getChartData()
  }

  getActualMoney() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.post(this.props.api.stats.financeStats, {}, config)
      .then((result) => {
        if (!this._calledComponentWillUnmount) {
          const data = result.data;
          this.setState({
            actualMoney: data ? data[data.length - 1].balance : 0
          });
        }
      }).catch(function (error) {
      console.error('Error axios:', error);
    });
  }

  getChartData() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    let chartData = this.state.chartData;
    axios.post(this.props.api.stats.financeStats, {
      from: this.state.startDate,
      to: this.state.endDate
    }, config).then((result) => {
      if (!this._calledComponentWillUnmount) {
        const data = result.data;
        chartData.labels = data.map((elem) => {
          return moment(elem._id).format('l');
        });
        chartData.datasets[0].data = data.map((elem) => elem.balance);
        this.setState({
          chartData: chartData
        });
      }
    }).catch(function (error) {
      console.error('Error axios:', error);
    });
  }

  init_chart() {
    return {
      labels: [],
      datasets: [
        {
          label: 'Vývoj financí v systému',
          fill: false,
          borderColor: '#007acc',
          backgroundColor: '#007acc',
          pointRadius: 5,
          pointHoverRadius: 10,
          data: []
        }
      ],
      options: {
        responsive: true,
        title: {
          display: true,
          text: 'Graf vývoje financí v systému'
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Datum'
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Obnos peněz v systému'
            }
          }]
        }
      }
    }
  };

  render() {
    return (
      <div id="financeStats">
        <div>
          <h3>Finance</h3>
        </div>
        <div className="row tile-count">
          <div className="col-md-2 col-sm-4 col-xs-6 tile-stats-count pull-right">
            <span className="count-top"><i className="fa fa-dollar"></i> Obnos peněz</span>
            <div className="count">{this.state.actualMoney}</div>
            <span className="count-bottom">aktuálně v systému</span>
          </div>
          <div className="col-md-10 col-sm-8 col-xs-6 pull-right">
            <FromToDateForm
              startDate={this.state.startDate} endDate={this.state.endDate}
              handleChangeStart={this.handleChangeStart}
              handleChangeEnd={this.handleChangeEnd}
              handleSubmit={this.handleSubmit}
            />
          </div>
        </div>
        <div className="myChart">
          <Line data={this.state.chartData} options={this.state.chartData.options} />
        </div>
      </div>
    );
  }
}

export default FinanceStats;


/** WEBPACK FOOTER **
 ** ./src/containers/Statistics/FinanceStats.js
 **/